export class InvoiceIssuerBank{
    constructor(
        public name: string,
        public iban: string,
        public bic: string,
        public id?: number
    ){}
}